import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "stock-items" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "stock-items-header col-md-6 col-sm-12 q-pr-xl" }
const _hoisted_4 = { class: "eb-title flex justify-between items-center q-mb-sm" }
const _hoisted_5 = { class: "buttons" }
const _hoisted_6 = { class: "drag-handle-container" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "card-title" }
const _hoisted_9 = {
  key: 0,
  class: "options flex"
}
const _hoisted_10 = { class: "add-stock-item column placeholder" }
const _hoisted_11 = { class: "add-stock-item column" }
const _hoisted_12 = { class: "add-stock-item__input" }
const _hoisted_13 = { class: "stock-details col-md-6 col-sm-12 q-pl-xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lock_closed_icon = _resolveComponent("lock-closed-icon")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_tick_icon = _resolveComponent("tick-icon")!
  const _component_label_box = _resolveComponent("label-box")!
  const _component_chevron_right_icon = _resolveComponent("chevron-right-icon")!
  const _component_trash_icon = _resolveComponent("trash-icon")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_d_button = _resolveComponent("d-button")!
  const _component_editable_block_input = _resolveComponent("editable-block-input")!
  const _component_stock_information_editstate = _resolveComponent("stock-information-editstate")!
  const _component_entry_search = _resolveComponent("entry-search")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.locked)
        ? (_openBlock(), _createBlock(_component_lock_closed_icon, {
            key: 0,
            class: "q-ml-sm lockicon",
            size: "24px"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[13] || (_cache[13] = _createElementVNode("h2", null, "Stock items", -1)),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.editingOrder)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    class: "q-mr-md order",
                    onClick: _ctx.revertOrder,
                    unelevated: "",
                    rounded: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: "undo",
                        left: ""
                      }),
                      _cache[11] || (_cache[11] = _createElementVNode("span", null, "Reset order", -1))
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.editingOrder)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 1,
                    class: "order",
                    onClick: _ctx.saveOrder,
                    unelevated: "",
                    rounded: "",
                    color: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_tick_icon, { left: "" }),
                      _cache[12] || (_cache[12] = _createElementVNode("span", null, "Save order", -1))
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          (!_ctx.locked)
            ? (_openBlock(), _createBlock(_component_draggable, _mergeProps({
                key: 0,
                modelValue: _ctx.editState,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editState) = $event))
              }, _ctx.dragOptions, {
                handle: ".drag",
                onStart: _ctx.startDrag,
                onEnd: _cache[1] || (_cache[1] = ($event: any) => (_ctx.drag = false)),
                "item-key": "sys.id"
              }), {
                item: _withCtx(({ element }) => [
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["component-card q-mb-md", {'active': element.sys.id === _ctx.active}]),
                      key: element.sys.id,
                      onClick: ($event: any) => (_ctx.setActiveComponent(element.sys.id))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(element.ean?.length ? element.ean[0] : ''), 1),
                      _createElementVNode("h5", _hoisted_8, _toDisplayString(`${element.count}x ${element.title}`), 1),
                      (element.props)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.props, (prop) => {
                              return (_openBlock(), _createBlock(_component_label_box, {
                                "model-value": prop,
                                key: prop
                              }, null, 8, ["model-value"]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (element.sys.id !== _ctx.active)
                        ? (_openBlock(), _createBlock(_component_chevron_right_icon, {
                            key: 1,
                            class: "open",
                            size: "20px"
                          }))
                        : (_openBlock(), _createBlock(_component_trash_icon, {
                            key: 2,
                            class: "remove",
                            onClick: ($event: any) => (_ctx.removeComponents(element)),
                            size: "20px"
                          }, null, 8, ["onClick"]))
                    ], 10, _hoisted_7))
                  ])
                ]),
                _: 1
              }, 16, ["modelValue", "onStart"]))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(_component_d_button, {
            class: "btn secondary q-mb-sm",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addComponentDialog.show = true)),
            unelevated: "",
            flat: "",
            dense: ""
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createElementVNode("div", { class: "t-icon" }, "W", -1),
              _createElementVNode("span", null, "Search", -1)
            ])),
            _: 1
          }, 512), [
            [_vShow, !_ctx.locked && !_ctx.creatingNewStockItem]
          ]),
          _withDirectives(_createVNode(_component_d_button, {
            class: "btn secondary q-mb-sm",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.creatingNewStockItem = true)),
            unelevated: "",
            flat: "",
            dense: ""
          }, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [
              _createElementVNode("div", { class: "t-icon" }, "k", -1),
              _createElementVNode("span", null, "New Stock item", -1)
            ])),
            _: 1
          }, 512), [
            [_vShow, !_ctx.locked && !_ctx.creatingNewStockItem]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_10, "Save the product before adding stock-items", 512), [
            [_vShow, _ctx.locked]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("div", _hoisted_12, [
              _createVNode(_component_editable_block_input, {
                modelValue: _ctx.newStockItemTitle,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newStockItemTitle) = $event)),
                label: "Title",
                standalone: ""
              }, null, 8, ["modelValue"]),
              (!_ctx.locked)
                ? (_openBlock(), _createBlock(_component_d_button, {
                    key: 0,
                    class: "btn secondary q-mt-md cancel-add-item",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.creatingNewStockItem = false)),
                    unelevated: "",
                    flat: "",
                    dense: ""
                  }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createElementVNode("span", null, "Cancel", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.locked)
                ? (_openBlock(), _createBlock(_component_d_button, {
                    key: 1,
                    class: "btn secondary q-mt-md",
                    onClick: _ctx.addComponentDialog.addComponent,
                    unelevated: "",
                    flat: "",
                    dense: "",
                    disabled: !_ctx.newStockItemTitle
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: "add",
                        size: "22px"
                      }),
                      _cache[17] || (_cache[17] = _createElementVNode("span", null, "Confirm", -1))
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"]))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, _ctx.creatingNewStockItem]
            ])
          ], 512), [
            [_vShow, !_ctx.locked]
          ])
        ]),
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "divider md" }, null, -1)),
        _createElementVNode("div", _hoisted_13, [
          (_ctx.activeComponent)
            ? (_openBlock(), _createBlock(_component_stock_information_editstate, {
                key: _ctx.activeComponent?.sys?.id,
                component: _ctx.activeComponent,
                "onUpdate:component": _cache[6] || (_cache[6] = (id, payload) => _ctx.$emit('update:component', id, payload)),
                onCancel: _cache[7] || (_cache[7] = ($event: any) => (_ctx.editingValue = false)),
                editing: _ctx.editingValue,
                "onUpdate:editing": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editingValue) = $event)),
                "product-id": _ctx.productId,
                "prop-values": _ctx.propValues
              }, null, 8, ["component", "editing", "product-id", "prop-values"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_entry_search, {
      show: _ctx.addComponentDialog.show,
      "content-type": "stock",
      model: _ctx.model,
      request: _ctx.requestHandler,
      config: { requests: { limit: 100 } },
      onSelection: _cache[9] || (_cache[9] = s => { s.selection.forEach(_ctx.addComponentDialog.select); _ctx.addComponentDialog.addSelection(); _ctx.addComponentDialog.show = false}),
      onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addComponentDialog.show = false)),
      style: {"min-width":"320px","z-index":"9999"}
    }, null, 8, ["show", "model", "request"])
  ], 64))
}